import jwt_decode from 'jwt-decode';
export default {
    name: "sendBillAuditManage",
	mounted: function () {
		this.init();
	},
    data() {
        return {
            searchForm: {
                recCompany: null,
                recAuditState: null,
				sendAuditState: null,
				signAuditState: null,
				applyTime:null,
				sendAuditTime:null,
				recFristAuditTime:null,
				recFinalAuditTime:null,
				signAuditTime:null,
                page: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    methods: {
		init(){
            let conditionParam = this.$routerUtil.getParam();
            if(conditionParam && conditionParam.searchForm){
                conditionParam = conditionParam.searchForm;
            }
			console.log(conditionParam);
			this.$routerUtil.clearParam();
			if(conditionParam){
                this.$nextTick(() => {
                    this.searchForm = conditionParam;
                    this.doSearch();
                });
			}
		},
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.page = val;
            this.doSearch();
        },
		rowClick(row){
			this.$refs.table.toggleRowSelection(row);
		},
        handleSelectionChange(val) {
            this.selected = val;
        },
        doReset(){
            this.searchForm.recCompany="";
            this.searchForm.recAuditState="";
            this.searchForm.sendAuditState="";
            this.searchForm.signAuditState="";
            this.searchForm.applyTime=null,
            this.searchForm.sendAuditTime=null,
            this.searchForm.recFristAuditTime=null,
            this.searchForm.recFinalAuditTime=null,
            this.searchForm.signAuditTime = null
		},
        doSearch() {
            var that= this;
			const condition = new Object();
			condition.pageIndex = that.searchForm.page;
			condition.pageSize = that.searchForm.pageSize;
			condition.receiveCompanyName= that.searchForm.recCompany;
			condition.rcAuditStatus = that.searchForm.recAuditState;
			condition.scAuditStatus = that.searchForm.sendAuditState;
			condition.signatureAuditStatus = that.searchForm.signAuditState;
			if(that.searchForm.applyTime){
				condition.createTimeBeginTime = that.searchForm.applyTime[0];
				condition.createTimeEndTime = that.searchForm.applyTime[1];
			}
			if(that.searchForm.sendAuditTime){
				condition.scfAuditUserDayBeginTime = that.searchForm.sendAuditTime[0];
				condition.scfAuditUserDayEndTime = that.searchForm.sendAuditTime[1];
			}
			if(that.searchForm.recFristAuditTime){
				condition.rcfAuditUserDayBeginTime = that.searchForm.recFristAuditTime[0];
				condition.rcfAuditUserDayEndTime = that.searchForm.recFristAuditTime[1];
			}
			if(that.searchForm.recFinalAuditTime){
				condition.rcsAuditUserDayBeginTime = that.searchForm.recFinalAuditTime[0];
				condition.rcsAuditUserDayEndTime = that.searchForm.recFinalAuditTime[1];
            }
            // 签章方审核时间
            if(that.searchForm.signAuditTime){
				condition.signAuditUserDayBeginTime = that.searchForm.signAuditTime[0];
				condition.signAuditUserDayEndTime = that.searchForm.signAuditTime[1];
			}
            const param = this.$paramUtil.clearEmpty(condition);
            // param.systemCode = JSON.parse(sessionStorage.getItem('currentSystem')).code;
            this.$axios.get('/api/receipts/recordManage', {params: param}).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
		doApply(){
            const row = this.getSelectedRow();
            const token = jwt_decode(sessionStorage.getItem('token'));
			// 当前登录人公司id
            const customerCompanyId = token.customerCompanyId;
			if (row) {
                if (row.billSignatureFile.length === 0) {
                    this.$message({
                        message: this.$t('common.message.needModifyBill'),
                        type: 'warning',
                        center: true
                    });
                    return;
                }
                if(!row.signatureCompanyId){
                    this.$message({
                        message: this.$t('common.message.sendModify'),
                        type: 'warning',
                        center: true
                    });
                    return;
                }
                // 发单公司id
				// 您已经完成审核操作，不需重复操作
				if (customerCompanyId === row.sendCompanyId && row.scfAuditResult === 1) {
					this.$message({
                        message: this.$t('common.message.alreadyAudit'),
                        type: 'warning',
                        center: true
                    });
                    return null
				}
				// 签章公司id
				// 您已经完成审核操作，不需重复操作
				if (customerCompanyId === row.signatureCompanyId && row.signatureAuditResult === 1) {
					this.$message({
                        message: this.$t('common.message.alreadyAudit'),
                        type: 'warning',
                        center: true
                    });
                    return null
                }
				const conditionData = new Object();
				conditionData.searchForm = this.searchForm;
				conditionData.row = row;
				this.$router.push('SendBillAudit');
				this.$routerUtil.setParam(conditionData);
			}
		},
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        }
    }
}
